import { render } from "./ServiceMaintenance.vue?vue&type=template&id=0a7070c8"
import script from "./ServiceMaintenance.vue?vue&type=script&lang=js"
export * from "./ServiceMaintenance.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__